import React from 'react';
import { FileText, Download } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function FileMessage({ message, isMe }) {
  const fileUrl = `${BACKEND_URL}${message.file_url}`;
  if (message.is_image) {
    return (
      <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="block" data-testid={`file-img-${message.id}`}>
        <img src={fileUrl} alt={message.file_name} className="max-w-[200px] max-h-[160px] rounded-lg object-cover border border-white/20" loading="lazy" />
        <p className={`text-[9px] mt-1 truncate ${isMe ? 'text-blue-200' : 'text-slate-400'}`}>{message.file_name}</p>
      </a>
    );
  }
  return (
    <a href={fileUrl} target="_blank" rel="noopener noreferrer" data-testid={`file-doc-${message.id}`}
      className={`flex items-center gap-2 px-2 py-1.5 rounded-lg ${isMe ? 'bg-blue-500/30' : 'bg-slate-100'}`}>
      <FileText size={18} className={isMe ? 'text-blue-100' : 'text-blue-600'} />
      <div className="flex-1 min-w-0">
        <p className={`text-xs font-semibold truncate ${isMe ? 'text-white' : 'text-blue-900'}`}>{message.file_name}</p>
        <p className={`text-[9px] uppercase ${isMe ? 'text-blue-200' : 'text-slate-400'}`}>{message.file_type}</p>
      </div>
      <Download size={14} className={isMe ? 'text-blue-200' : 'text-slate-400'} />
    </a>
  );
}
